export const ROTATION_PERIOD_MS = 500;
export const PULSE_PERIOD_MS = 1400;
export const DASH_MINIMUM = 0.3;
export const DASH_MAXIMUM = 0.7;

// Every Spinner derives its starting frame from this shared origin, so an instance that
// replaces another (e.g. remounted elsewhere in the tree) resumes the same cycle instead
// of visibly restarting it.
const SPINNER_CLOCK_ORIGIN_MS = Date.now();

/** Position within a repeating cycle of `periodMs`, as a fraction in [0, 1). */
export function getSpinnerCyclePhase(periodMs: number, nowMs: number = Date.now()): number {
  const elapsed = (nowMs - SPINNER_CLOCK_ORIGIN_MS) % periodMs;
  return (elapsed < 0 ? elapsed + periodMs : elapsed) / periodMs;
}
